export default __webpack_public_path__ + "static/media/ithiri3.6d90cbd7.png";